import { useCallback, useEffect, useRef, useState } from "react";
import Dialog from "./Dialog";
import { getRTKLabel } from "./helper";
import { ref, set } from "firebase/database";

const UwbLocationSaveDialog = ({
  isOpenSave,
  onClose,
  gps,
  db,
  setAlertMsg,
  savedLocs,
}) => {
  const [label, setLabel] = useState("");
  const handleChange = useCallback((ev) => setLabel(ev.target.value), []);
  const [height, setHeight] = useState();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleHeightChange = useCallback(
    (ev) => setHeight(ev.target.value),
    []
  );

  const handleClose = useCallback(() => {
    setLabel("");
    onClose();
  }, [onClose]);

  const inputRef = useRef();

  useEffect(() => {
    inputRef.current.focus();
  }, [isOpenSave]);

  const save = useCallback(
    (e) => {
      e.preventDefault();
      if (label) {
        set(ref(db, "savedLocation/" + label), { ...gps, lrf_height: height })
          .then(() => {
            handleClose();
            setConfirmOpen(false);
            setAlertMsg({
              color: "#039105",
              text: `${label} - GPS data saved`,
            });
          })
          .catch((err) => {
            setAlertMsg({
              color: "#f44336",
              text: err.toString(),
            });
          });
      }
    },
    [db, label, gps, setAlertMsg, handleClose, setConfirmOpen]
  );

  const handleSubmitClick = useCallback(
    (e) => {
      if (Object.keys(savedLocs).includes(label)) {
        setConfirmOpen(true);
      } else {
        save(e);
      }
    },
    [savedLocs, setConfirmOpen, label, save]
  );

  const handleCancel = useCallback(() => {
    setConfirmOpen(false);
  }, [setConfirmOpen]);

  return (
    <Dialog isOpen={isOpenSave} onClose={handleClose}>
      <div>
        <input
          value={label}
          onChange={handleChange}
          type="text"
          placeholder="UWB node id/name/anchor number"
          ref={inputRef}
        />
        <input
          value={height}
          onChange={handleHeightChange}
          type="text"
          placeholder="LRF reading - Distance from ground to GPS antenna"
        />
        {!!gps && (
          <div>
            <dl className="clearfix">
              <dt>Latitude:</dt>
              <dd>{gps.gcs[0]}</dd>
            </dl>
            <dl className="clearfix">
              <dt>Longitude:</dt>
              <dd>{gps.gcs[1]}</dd>
            </dl>
            <dl className="clearfix">
              <dt>Altitude:</dt>
              <dd>{gps.gcs[2]} m</dd>
            </dl>
            <dl className="clearfix">
              <dt>Accu:</dt>
              <dd>{`${gps.accu} m (RTK: ${getRTKLabel(gps.rtk)})`}</dd>
            </dl>
            <button
              onClick={handleSubmitClick}
              style={{ marginTop: 10 }}
              className="button"
              disabled={!label || confirmOpen}
            >
              Submit
            </button>
          </div>
        )}
      </div>
      {confirmOpen && (
        <div>
          <p>GPS data for anchor id {label} already exists. Overwrite?</p>
          <button
            className="button"
            style={{ padding: 10, marginRight: "50px" }}
            onClick={save}
          >
            OK
          </button>
          <button
            className="button"
            style={{ padding: 10 }}
            onClick={() => handleClose()}
          >
            Cancel
          </button>
        </div>
      )}
    </Dialog>
  );
};

export default UwbLocationSaveDialog;
